export const concatObservacao = (atual, novoValor, usuario) => {
  if (novoValor) {
    if (atual) {
      return `${atual}\n\n${usuario}:\n${novoValor}`
    }
    return `${usuario}:\n${novoValor}`
  }
  return atual
}
